import { ListDrilldownHandler, Table } from "@mcleod/components";
import { ArrayUtil, ModelRow, ObjectUtil, UserType } from "@mcleod/core";
import { ModelUsers } from "../models/ModelUsers";
import { UserList } from "./UserList";

export class UserListDrilldownHandler extends ListDrilldownHandler<UserList> {
    override async getTableFromLayout(): Promise<Table> {
        const userRows = await this.getUsersForKeys();
        if (ArrayUtil.isEmptyArray(userRows))
            return null;

        // if we are drilling down to multiple users, we assume they are all the same type and appear in the same table
        const firstUser = userRows[0];
        const userType = ObjectUtil.getEnumValue(UserType, firstUser.get("web_user_type"));

        const userTabConfig = this.layout.userTabConfigMap.get(userType);
        if (!userTabConfig) return null;

        const userTableLayout = userTabConfig.layout;


        // Drilldowns might be trying to open inactive user records, so clear the "isActive" filter if needed
        const firstIsActive = firstUser.get("is_active");
        if (userRows.every(row => row.get("is_active") === firstIsActive)) {
            userTableLayout.textboxSearchIsActive.setSelectedItemFromValue(firstIsActive);
        } else {
            userTableLayout.textboxSearchIsActive.selectedItems = null;
        }

        userTabConfig.tab.select();

        if (!this.layout.preventAutoSearchOnLoad) {
            userTableLayout.getSourceUsers().executeValidatedSearch();
        } else {
            // populate the User Id textbox with proper lm data for multi-value drilldown
            const searchRow =  userTableLayout.getSourceUsers().searchRow;
            searchRow.setLookupModelData("id", userRows);
            searchRow.setValueAndLookupModelData("id",
                userRows.map(row => row.getString("id")).join(","),
                userRows.map(row => row.withLookupModelDataType()));
            userTableLayout.textboxSearchId.displayData(searchRow, null, 0);
        }

        return userTabConfig.layout.tableUsers;
    }

    private async getUsersForKeys(): Promise<ModelRow[]> {
        const searchValue = this.keyValues?.length > 1 ? `in ${this.keyValues.join(",")}` : this.keyValues?.[0];
        if (searchValue == null) {
            return undefined;
        }

        const filter = { "id": searchValue, _field_list: { extraFields: "common/user-list-drilldown" } };
        const result = await new ModelUsers().search(filter);
        return result.modelRows;
    }
}
